import { dateTransformer } from "../utils/dateTransformer";
import { formatCnpj, formatCpf } from "../utils/formatters";

export const documentsFieldSettings = {
  default: (name: string) => ({
    label: name?.toUpperCase() || "",
    mask: "",
    defaultValueTransformer: (defaultValue: string) => defaultValue,
  }),
  issued_on_date: {
    label: "Data de expedição",
    mask: "00/00/0000",
    defaultValueTransformer: (defaultValue: string) => {
      if (defaultValue.match(/\d{1,2}\/\d{1,2}\/\d{2,4}/)) {
        return defaultValue;
      }

      return dateTransformer(defaultValue)
    },
  },
  expires_at: {
    label: "Data de expiração",
    mask: "00/00/0000",
    defaultValueTransformer: (defaultValue: string) => {
      if (defaultValue.match(/\d{1,2}\/\d{1,2}\/\d{2,4}/)) {
        return defaultValue;
      }

      return dateTransformer(defaultValue)
    },
  },
  cpf: {
    label: "CPF",
    mask: "000.000.000-00",
    defaultValueTransformer: (defaultValue: string) => formatCpf(defaultValue),
  },
  cnpj: {
    label: "CNPJ",
    mask: "00.000.000/0000-00",
    defaultValueTransformer: (defaultValue: string) => formatCnpj(defaultValue),
  },
  rg: {
    label: "RG",
    mask: "0000000000",
    defaultValueTransformer: (defaultValue: string) => defaultValue,
  },
};
